const SIDE_NAV_WIDTH = 220;
const SIDE_NAV_COLLAPSED_WIDTH = 80;

export { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH };
